import Fuse from 'fuse.js/dist/fuse.common.js';

export default function initSearchField (
  searchData = null,
  searchOptions = null,
  searchInput = null,
  resultsContainer = null,
  searchContainer = null,
  mainTextElement = null,
  resetSearchButton = null
)
{

  let normalizedData = searchData.map(function(item){
    let normalizedItem = Object.assign({}, item);
    normalizedItem.content = normalizedItem.content.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normalizedItem;
  });

  if (searchData !== null && searchOptions !== null && searchInput !== null && resultsContainer !== null) {

    let fuse = new Fuse(normalizedData, searchOptions);

    let searchQueryElement = searchContainer.querySelector('.search-results__query'),
    resultsCountElement = searchContainer.querySelector('.search-results__count-value'),
    resultsPluralElement = searchContainer.querySelector('.search-results__count-plural');

    searchInput.addEventListener('change', function(event) {

      let searchPattern = event.target.value,
      normalizedSearchPattern = searchPattern.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      let searchPatternLenght = normalizedSearchPattern.length;

      searchQueryElement.innerHTML = `'${searchPattern}'`;
      resultsCountElement.innerHTML = '0';
      resultsPluralElement.style.display = 'inline';


      if (normalizedSearchPattern !== '') {

        let searchResults = fuse.search(normalizedSearchPattern),
        resultsHTML = '',
        rgxp = new RegExp(normalizedSearchPattern, 'i');

        if (searchResults.length > 0) {
          resultsCountElement.innerHTML = searchResults.length;
          searchContainer.classList.add('search-complete');
          if (searchResults.length == 1) {
            resultsPluralElement.style.display = 'none';
          } else {
            resultsPluralElement.style.display = 'inline';
          }

          console.log(searchResults);

          searchResults.sort(function(a, b) {
            if (a.hasOwnProperty('item') && b.hasOwnProperty('item')) {
              if (a['item'].hasOwnProperty('parent') && a['item'].hasOwnProperty('parent')) {
                return a['item']['id'] - b['item']['id'] || a['item']['parent'] - b['item']['parent'];
              }
            }
          });

          console.log(searchResults);

          searchResults.map(function(result) {

            let matchingSource = searchData.filter(function(searchDataItem){
              return searchDataItem.id == result.item.id;
            });

            let matchingContent = matchingSource[0].content;

            let resultDomain = result.matches[0].value,
            lowerCaseResultDomain = resultDomain.normalize('NFC').replace(/[\u0300-\u036f]/g, ''),
            resultMatches = lowerCaseResultDomain.search(rgxp),
            offset = 40,
            matchStart = resultMatches - offset,
            matchEnd = resultMatches + searchPatternLenght + 3 * offset,
            beforeMatch = matchingContent.substring(matchStart, resultMatches),
            afterMatch = matchingContent.substring(resultMatches + searchPatternLenght, matchEnd),
            matchText = matchingContent.substring(resultMatches, resultMatches + searchPatternLenght),
            outputText = '...' + beforeMatch + '<b>' + matchText + '</b>' + afterMatch + '...',
            encodedSearchParameter = encodeURI(searchPattern),
            breadcrumbPrefix = (result.item.parent_title == '') ? '' : result.item.parent_title + ' / '
            let resultItemHTML =
            `<a href='${ result.item.url }?search=${encodedSearchParameter}' class='result-item'>
            <p class='result-item__page'>${ breadcrumbPrefix }${ result.item.title }</p>
            <p class='result-item__excerpt'><i>${ outputText }</i></p>
            </a>`;
            resultsHTML+= resultItemHTML;

          });

          // let indices = [];
          // let normalizedMainText = mainText.normalize('NFC').replace(/[\u0300-\u036f]/g, '');
          // let mainText = mainTextElement.innerHTML;

          clearHighlights(mainTextElement, 'result-highlight-item');

          let hasHighlightedText = highlightText(mainTextElement, searchPattern);

          if (hasHighlightedText == true) {
            let bodyRect = document.body.getBoundingClientRect(),
            firstResultItem = mainTextElement.querySelector('#resultItem0'),
            firstResultRect,
            windowVerticalCenter = window.innerHeight / 2;

            if (firstResultItem && typeof firstResultItem.getBoundingClientRect() === 'function') {
              firstResultRect =  firstResultItem.getBoundingClientRect();
            }

            if (firstResultRect && firstResultRect.hasOwnProperty('top') && bodyRect && bodyRect.hasOwnProperty('top')) {
              document.documentElement.scrollTop = firstResultRect.top - bodyRect.top - windowVerticalCenter;
            }

          }

        } else {
          searchContainer.classList.add('search-complete');
          let noResultsMessage = 'Não foram encontrados resultados para a busca';
          resultsHTML = `<p class='search-results__no-results'>${ noResultsMessage }</p>`;
          console.log(noResultsMessage);
        }

        resultsContainer.innerHTML = resultsHTML;

      } else {
        resultsContainer.innerHTML = '';
      }
    });

    resetSearchButton.addEventListener('click', function() {

      searchContainer.classList.remove('search-complete');
      searchInput.focus();
      searchInput.value = '';
      clearHighlights(mainTextElement, 'result-highlight-item');
      
      if(!searchcontainer.classList.contains('focus')) {
        searchcontainer.classList.add('focus');
      }

    });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const searchQuery = urlParams.get('search');

    if (searchQuery !== null) {
      let changeEvent = new Event('change');
      searchInput.value = searchQuery;
      searchInput.dispatchEvent(changeEvent);
    }

    if (searchContainer !== null ) {
      console.log('inicializa dropdown ou outra estrutura');
    }

  } else {
    console.log('Você deve passar o caminho para o arquivo json e as opções da busca')
  }
}

function textNodesUnder(el){
  let n,
  a = [],
  walk = document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null,false);
  while(n = walk.nextNode()) {
    a.push(n);
  }
  return a;
}

function highlightText(containerElement, searchTerm) {
  console.log('start highlighting');
  console.log(containerElement, searchTerm);
  let alltext = textNodesUnder(containerElement);
  console.log(alltext);
  let resultIndex = 0;
  let normalizedSearchTerm = searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  alltext.forEach(function(node) {
    let originalNodeValue = node.nodeValue;

    let normalizedNodeValue = originalNodeValue.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    // console.log(normalizedSearchTerm);
    // normalize NFC não normaliza acentos e diacríticos
    console.log(normalizedNodeValue);
    console.log(normalizedNodeValue.length);

    if(normalizedNodeValue.includes(normalizedSearchTerm)) {
      let splitBaseString = normalizedNodeValue.split(normalizedSearchTerm);
      let substitutionPositions = [];
      let currentStringPosition = 0;
      splitBaseString.forEach(function(substring, index){
        if (index < splitBaseString.length - 1) {
          substitutionPositions.push(
            [
              currentStringPosition,
              currentStringPosition + substring.length,
            ]
          );
          currentStringPosition = currentStringPosition + substring.length + normalizedSearchTerm.length;
        }
      });

      console.log(substitutionPositions);

      substitutionPositions.forEach(function(position){
        let startPosition = position[0];
        let endPosition = position[1];
        let substringSlice = originalNodeValue.slice(startPosition, endPosition);
        let resultMatch = originalNodeValue.slice(endPosition, endPosition + searchTerm.length);

        let newTextNode = document.createTextNode(substringSlice);
        let highlightedTextNode = document.createElement('span');

        highlightedTextNode.classList.add('result-highlight-item');
        highlightedTextNode.setAttribute('id', `resultItem${resultIndex}`);
        highlightedTextNode.innerHTML = resultMatch;

        node.parentNode.insertBefore(newTextNode, node);
        console.log(substringSlice);

        node.parentNode.insertBefore(highlightedTextNode, node);
        console.log(resultMatch);

      });

      let lastSlice = originalNodeValue.slice(currentStringPosition, originalNodeValue.length);

      if (lastSlice.length > 0) {
        let newTextNode = document.createTextNode(lastSlice);
        node.parentNode.insertBefore(newTextNode, node);
      }

      console.log('-----');

      node.remove();

      resultIndex++;

    }
  });
  if (alltext.length > 0) {
    return true;
  } else {
    return false;
  }
}

function clearHighlights(containerElement, highlightClass) {
  console.log(containerElement);
  let allHighlights = containerElement.querySelectorAll(`.${highlightClass}`);
  allHighlights.forEach(function(highlight) {
    let newTextNode = document.createTextNode(highlight.innerHTML);
    highlight.parentNode.insertBefore(newTextNode, highlight);
    highlight.remove();
    if (newTextNode.previousSibling && newTextNode.previousSibling.nodeType == 3) {
      newTextNode.nodeValue = newTextNode.previousSibling.nodeValue + newTextNode.nodeValue;
      newTextNode.previousSibling.remove();
    }
    if (newTextNode.nextSibling && newTextNode.nextSibling.nodeType == 3) {
      newTextNode.nodeValue = newTextNode.nodeValue + newTextNode.nextSibling.nodeValue;
      newTextNode.nextSibling.remove();
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/components/search.js